export default [
  {
    path: '/home',
    component: () => import('../../views/home/Index.vue'),
    name: 'home',
    meta: {
      auth: 0,
      title: '首页',
    },
  },
  {
    path: '/download',
    component: () => import('../../views/home/Download.vue'),
    name: 'download',
    meta: {
      auth: 0,
      title: 'CFMOTO RIDE APP下载',
    },
  },
  {
    path: '/download-cross',
    component: () => import('../../views/home/DownloadCross.vue'),
    name: 'download-cross',
    meta: {
      auth: 0,
      title: 'CFMOTO RIDE SYNC',
    },
  },
  {
    path: '/webview',
    component: () => import('../../views/home/Webview.vue'),
    name: 'webview',
    meta: {
      auth: 0,
      title: '',
    },
  },
];
